(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'EditVideo'
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load($form)
	{
		var catId       = '';
		var parentLabel = '';

		var catSelect   = $form.find("#editvideo-agent_video_category_id").val();
		var parentGroup = $form.find("#editvideo-agent_video_category_id :selected").parent().attr('label');

		console.log(catSelect, 'CatSelect');


		if ((catSelect === '' || catSelect === null) || parentGroup === 'Global Categories') {
			$('.edit-video-subcat').addClass('hidden');
		}


		$form.find("#editvideo-agent_video_category_id").on('change', function viewSubcategory() {
			catId       = $(this).val();
			parentLabel = $(this.options[this.selectedIndex]).parent().attr('label');

			if (parentLabel === 'Global Categories') {
				$('.edit-video-subcat').addClass('hidden');
			}

			if ((catId !== '' || catId !== null) && parentLabel !== 'Global Categories') {
				Adzuki.Ajax.get('/Videos/getSubCatList/' + catId)
					.then(function success(data) {
						if (data[0] === 0) {
							$('.edit-video-subcat').addClass('hidden');
						} else {
							$('.edit-video-subcat').removeClass('hidden');
							$("#editvideo-agent_video_subcategory_id").html(data);
						}
					});
			}
		});

	};



}(jQuery, window.Adzuki || {}));
